import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/* cookie-only sessions: the httpOnly access/refresh cookies ride along with withCredentials — nothing is kept in localStorage */
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

/* the wolf's tongue rides on every call so the server can write chapters in it while the wolf is away */
api.interceptors.request.use((config) => {
  try { const l = localStorage.getItem("dgl_lang"); if (l) config.headers["X-Lang"] = l; } catch {}
  return config;
});

const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout", "/auth/google/session"];
let refreshing = null;

/* a 401 on a session call means the 15-minute access cookie lapsed: mint a new one from the refresh cookie once, then replay the request */
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (!response || response.status !== 401 || !config || config._retried || NO_REFRESH.some((p) => (config.url || "").includes(p))) throw error;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
    } catch { throw error; }
    return api({ ...config, _retried: true });
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
